import IntegrityRoleGrid from 'components/UserRole';
import {Column, Lookup} from 'devextreme-react/data-grid';
import React, {useState} from 'react';
import {i18n2} from '../../i18n/i18n';
import useLoadSpac from '../../spac/hooks/useLoadSpac';
import {lookupModality} from 'features/instance/component/StageGrid';
import {useSelector} from 'react-redux';
import PopupReport from './../../../components/Popups/PopupReport';

const SpacReadOnly = () => {
  const loadSpac = useLoadSpac('readonlyJOIN');
  const [openReport, setOpenReport] = useState(false);
  const filters = useSelector((state: any) => state.gridReducer.filters);

  return (
    <>
      <IntegrityRoleGrid
        dataSource={loadSpac}
        allowIntegrity={false}
        autowidth={true}
        allowActions={false}
        id={['iD_Spac', 'iD_Instance', 'iD_Course', 'employee_Nr']}
        addCustomToolbar={[
          {
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'event',
              hint: i18n2._('Reporte'),
              onClick: () => setOpenReport(true),
            },
          },
        ]}
        shouldSaveOnlyFilters={true}
        exportName="Spac-consult-export">
        <Column
          caption={i18n2._('Numero de SPAC')}
          dataField="iD_Spac"
          defaultSortOrder={'asc'}
        />
        <Column caption={i18n2._('Nombre de SPAC')} dataField="name" />
        <Column caption={i18n2._('#Instancia')} dataField="iD_Instance" />
        <Column caption={i18n2._('#Curso')} dataField="iD_Course" />
        <Column
          caption={i18n2._('Numero de empleado')}
          dataField="employee_Nr"
        />
        <Column caption={i18n2._('CWID')} dataField="cwid" />
        <Column
          caption={i18n2._('Nombre del empleado')}
          dataField="employee_Name"
        />
        <Column caption={i18n2._('Sector')} dataField="sector_Name" />
        <Column caption={i18n2._('Nombre del curso')} dataField="name_Course" />
        <Column
          caption={i18n2._('Fecha de expiración')}
          dataField="expiration_Date"
          dataType="date"
          format="dd/MM/yyyy"
          calculateCellValue={(row: any) => new Date(row.expiration_Date)}
        />
        <Column caption={i18n2._('Modality')} dataField="modality">
          <Lookup
            dataSource={lookupModality}
            valueExpr="id"
            displayExpr="name"
          />
        </Column>
      </IntegrityRoleGrid>
      <PopupReport
        open={openReport}
        setOpen={setOpenReport}
        name="Capacitacion_SPAC"
        url="api/Report/CapaSpacReport"
        filters={filters}
        pdfOnly={false}
      />
    </>
  );
};

export default SpacReadOnly;
